import http from '../config/http'
import router from '../router'
export default{
  // 用户登录
  userLogin ({dispatch, commit}, sendMsg) {
    http.postQs('game/login/', sendMsg.data, true)
      .then(res => {
        if (res.errorCode === 0) {
          let datas = {
            user_id: res.data.id,
            phoneNum: res.data.phoneNum,
            token: res.data.token
          }
          commit('SAVEUSER', datas)
          dispatch('userInfo', {}).then(() => {
            let returnUrl = sendMsg.returnUrl || '' // 登陆成功跳转页面
            if (returnUrl) {
              router.replace({path: returnUrl})
            } else {
              window.vm.$router.back(-1)
            }
          })
        }
      })
  },
  // 退出登录shide
  outLogin ({commit}, data) {
    // http.post('game/logout/', data)
    //   .then(res => {
    //     if (res.errorCode === 0) {
    //       commit('OUTLOGIN', false)
    //     }
    //   })
    commit('OUTLOGIN', false)
  },
  // 用户信息
  userInfo ({commit}, data) {
    return new Promise((resolve, reject) => {
      http.postJson('game/qryInfo/', data)
        .then(res => {
          if (res.errorCode === 0) {
            commit('USERINFO', res.data)
            resolve(res)
          }
        }).catch(error => {
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/vuex/actions.js